import { render, staticRenderFns } from "./work-queue.html?vue&type=template&id=283649a8&scoped=true&"
import script from "./work-queue.js?vue&type=script&lang=js&"
export * from "./work-queue.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283649a8",
  null
  
)

export default component.exports